export type { AboutSectionProps } from './AboutSection';
export { default } from './AboutSection';
